























import { Component, Vue, Prop } from 'vue-property-decorator';
import { IChildrenAvatarStub } from './types';

@Component
export default class ChildrenAvatarStub
  extends Vue
  implements IChildrenAvatarStub {
  @Prop({ type: String, default: 'N' })
  readonly gender!: string;

  get male() {
    return this.gender === 'M';
  }

  get female() {
    return this.gender === 'W';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/components/stub/ChildrenAvatarStub.vue